import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import { createUniqueId } from 'shared/utils/id/id';
import {
  FormChecklistAnswer,
  FormComplianceChecklistAnswer,
  FormNumericChecklistAnswer,
  FormOptionSelectionChecklistAnswer,
  FormTextChecklistAnswer,
} from './types';

function createComplianceAnswer(): FormComplianceChecklistAnswer {
  return {
    uniqueKeyId: createUniqueId(),
    type: AnswerType.Compliance,
    label: '',
    isRequired: false,
    optionLabels: [
      { option: ComplianceAnswerOption.passed, label: '' },
      { option: ComplianceAnswerOption.notPassed, label: '' },
    ],
  };
}

function createNumericAnswer(): FormNumericChecklistAnswer {
  return {
    uniqueKeyId: createUniqueId(),
    type: AnswerType.Numeric,
    label: '',
    isRequired: false,
    unit: undefined,
    normMin: undefined,
    normMax: undefined,
    rangeMin: undefined,
    rangeMax: undefined,
    step: undefined,
  };
}

function createTextAnswer(): FormTextChecklistAnswer {
  return {
    uniqueKeyId: createUniqueId(),
    type: AnswerType.Text,
    label: '',
    isRequired: false,
  };
}

function createOptionSelectionAnswer(): FormOptionSelectionChecklistAnswer {
  return {
    uniqueKeyId: createUniqueId(),
    type: AnswerType.OptionSelection,
    label: '',
    isRequired: false,
    options: [{ _id: createUniqueId(), label: '' }],
    isMultiselect: false,
  };
}

export function createFormChecklistAnswer(
  answerType: AnswerType
): FormChecklistAnswer {
  switch (answerType) {
    case AnswerType.Compliance:
      return createComplianceAnswer();
    case AnswerType.Numeric:
      return createNumericAnswer();
    case AnswerType.Text:
      return createTextAnswer();
    case AnswerType.OptionSelection:
      return createOptionSelectionAnswer();
  }
}

export function updateFormChecklistAnswer(
  answer: FormChecklistAnswer,
  updates: Partial<FormChecklistAnswer>
): FormChecklistAnswer {
  return { ...answer, ...updates } as FormChecklistAnswer;
}
